import React, { useState } from "react";

import { MobileDatePicker, MobileDatePickerProps } from "@mui/lab";
import { InputAdornment, TextField, TextFieldProps } from "@mui/material";
import { CalendarIcon } from "../../globals/design-system/icons";

type MoovsDatePickerProps = {
  onAccept?: (date: Date) => void;
  renderInputProps?: TextFieldProps;
  clearable?: boolean;
  disabled?: boolean;
} & Omit<
  MobileDatePickerProps,
  "onChange" | "renderInput" | "onClose" | "InputProps" | "clearable" | "open"
>;

function MoovsDatePicker(props: MoovsDatePickerProps) {
  const {
    renderInputProps = {},
    clearable = false,
    onAccept,
    disabled,
    ...otherProps
  } = props;

  // state
  const [openDatePicker, setOpenDatePicker] = useState(false);

  // event handlers
  const handleClosePicker = () => setOpenDatePicker(false);
  const handleOpenPicker = () => {
    if (!disabled) {
      setOpenDatePicker(true);
    }
  };

  const handleAccept = (date: Date) => {
    onAccept(date);
    handleClosePicker();
  };

  return (
    <MobileDatePicker
      {...otherProps}
      disabled={disabled}
      open={openDatePicker}
      clearable={clearable}
      onChange={() => {}}
      onAccept={handleAccept}
      onClose={handleClosePicker}
      inputFormat="ddd, D MMM"
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <CalendarIcon />
          </InputAdornment>
        ),
        style: { cursor: "pointer" },
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          onClick={handleOpenPicker}
          variant="outlined"
          fullWidth
          inputProps={{
            ...params.inputProps,
            style: { cursor: "pointer" },
          }}
          {...renderInputProps}
        />
      )}
    />
  );
}
export default MoovsDatePicker;
